<script setup lang="ts">
import { GROUP_BADGE_COLORS } from '~/shared/allergenHierarchy'

const props = defineProps<{
  /** Icon id for the SVG (a parent or standalone allergen/trait). */
  iconId: string
  /** Tooltip text (for a group: "Noten: Hazelnoot, Pistache"). */
  label: string
  /** Number of grouped sub-allergens; badge shows from 2. */
  badge?: number
}>()

const { styles } = useVariants('iconTooltip')
const { isOpen, onPointerEnter, onPointerLeave, onClick } = useIconTooltip()

const showBadge = computed(() => (props.badge ?? 0) >= 2)

// Badge circle colour comes from the group (theme-independent); the number
// stays white via the slot. Falls back to black for any unmapped group.
const badgeStyle = computed(() => ({
  backgroundColor: GROUP_BADGE_COLORS[props.iconId] ?? '#000000',
}))
</script>

<template>
  <span
    :class="styles.wrapper()"
    @click.stop="onClick"
    @pointerenter="onPointerEnter"
    @pointerleave="onPointerLeave"
  >
    <span
      :class="styles.trigger()"
      tabindex="0"
      role="img"
      :aria-label="label"
      @focus="onPointerEnter"
      @blur="onPointerLeave"
    >
      <MenuIcon :icon="iconId" />
      <span v-if="showBadge" :class="styles.badge()" :style="badgeStyle">{{ badge }}</span>
    </span>
    <span v-if="isOpen" role="tooltip" :class="styles.tooltip()">{{ label }}</span>
  </span>
</template>
